(function () {
  if (window.msProductAskDrawerInitialized) return;
  window.msProductAskDrawerInitialized = true;

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var drawer = document.getElementById('product-ask-drawer');
    if (!drawer) return;

    var body = document.body;
    var openButtons = document.querySelectorAll('[data-open-product-ask-drawer]');
    var closeButtons = drawer.querySelectorAll('[data-close-product-ask-drawer]');
    var askButton = drawer.querySelector('[data-open-judgeme-question]');
    var chips = drawer.querySelectorAll('[data-question-chip]');
    var previewWrap = drawer.querySelector('[data-question-preview-wrap]');
    var preview = drawer.querySelector('[data-question-preview]');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      body.classList.add('ms-ask-drawer-open');

      openButtons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      body.classList.remove('ms-ask-drawer-open');

      openButtons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var question = chip.getAttribute('data-question-chip') || '';
        window.msSelectedProductQuestion = question;

        chips.forEach(function (item) {
          item.classList.remove('is-active');
        });

        chip.classList.add('is-active');

        if (previewWrap && preview) {
          previewWrap.hidden = false;
          preview.textContent = question;
        }
      });
    });

    function normalizeText(text) {
      return (text || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function clickElement(el) {
      if (!el) return false;

      try {
        el.dispatchEvent(new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        }));
      } catch (e) {
        try {
          el.click();
        } catch (err) {}
      }

      return true;
    }

    function getJudgeMeWidget() {
      var selectors = [
        '#judgeme_product_reviews',
        '.jdgm-widget',
        '.jdgm-rev-widg',
        '[data-judgeme-widget]',
        '[id*="judgeme"]'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el) return el;
      }

      return null;
    }

    function findElementByText(root, selectors, patterns) {
      var scope = root || document;
      var nodes = scope.querySelectorAll(selectors);

      for (var i = 0; i < nodes.length; i++) {
        var text = normalizeText(nodes[i].textContent || nodes[i].innerText || '');
        for (var j = 0; j < patterns.length; j++) {
          if (text.indexOf(patterns[j]) !== -1) {
            return nodes[i];
          }
        }
      }

      return null;
    }

    function openQuestionsTab(widget) {
      var scope = widget || document;

      var selectors = [
        '.jdgm-subtab',
        '.jdgm-tab',
        '.jdgm-widget-actions-wrapper a',
        '.jdgm-widget-actions-wrapper button',
        '[role="tab"]',
        'button',
        'a'
      ].join(',');

      var patterns = [
        'questions',
        'fragen',
        'question'
      ];

      var tab = findElementByText(scope, selectors, patterns);
      if (tab) {
        clickElement(tab);
        return true;
      }

      return false;
    }

    function openAskQuestion(widget) {
      var scope = widget || document;

      var knownSelectors = [
        '.jdgm-ask-question-btn',
        '.jdgm-question-form-toggle',
        '.jdgm-question-form-open',
        '.jdgm-widget .jdgm-ask-question-btn',
        '.jdgm-widget .jdgm-question-form-toggle',
        '.jdgm-question-form-wrapper .jdgm-btn',
        '.jdgm-qna-ask-question',
        '.jdgm-question-form-btn'
      ];

      for (var i = 0; i < knownSelectors.length; i++) {
        var el = scope.querySelector(knownSelectors[i]);
        if (el) {
          clickElement(el);
          return true;
        }
      }

      var textMatch = findElementByText(
        scope,
        'button, a, [role="button"], input[type="button"], input[type="submit"]',
        [
          'ask a question',
          'frage stellen',
          'jetzt fragen',
          'question'
        ]
      );

      if (textMatch) {
        clickElement(textMatch);
        return true;
      }

      return false;
    }

    function fillQuestionField() {
      if (!window.msSelectedProductQuestion) return false;

      var fields = document.querySelectorAll(
        '.jdgm-question-form-wrapper textarea, ' +
        '.jdgm-question-form-wrapper input[type="text"], ' +
        '.jdgm-form textarea, ' +
        '.jdgm-form input[type="text"], ' +
        'textarea, input[type="text"]'
      );

      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        var marker = normalizeText(
          (field.getAttribute('placeholder') || '') + ' ' +
          (field.getAttribute('name') || '') + ' ' +
          (field.getAttribute('id') || '') + ' ' +
          (field.getAttribute('aria-label') || '')
        );

        if (
          marker.indexOf('question') !== -1 ||
          marker.indexOf('frage') !== -1 ||
          marker.indexOf('write your question here') !== -1
        ) {
          field.focus();
          field.value = window.msSelectedProductQuestion;
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }

      return false;
    }

    function triggerJudgeMeFlow() {
      var widget = getJudgeMeWidget();

      if (!widget) {
        return;
      }

      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });

      setTimeout(function () {
        openQuestionsTab(widget);

        setTimeout(function () {
          var askOpened = openAskQuestion(widget);

          setTimeout(function () {
            var filled = fillQuestionField();

            if (!askOpened && !filled) {
              widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 500);
        }, 500);
      }, 500);
    }

    if (askButton) {
      askButton.addEventListener('click', function () {
        closeDrawer();
        setTimeout(triggerJudgeMeFlow, 250);
      });
    }
  });
})();